import { useLocation, useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import LaunchIcon from '@mui/icons-material/Launch';
import { LinkButton } from 'Components/Button';
//import reCAPTCHA from 'Images/recaptchaimg.png';
import ahrqlogo from 'Images/ahrqlogo.png';
import psoppclogo from 'Images/psoppclogo.png';
import { PATHS } from 'Utils/PagePaths';
import { useEffect, useRef, useState } from 'react';
import useWindowSize from './WindowSize';
import { Link } from 'react-router-dom';

function PublicFooter ({ pageRef }) {
    const footerRef = useRef(null)
    const navigate = useNavigate();
    ///const { width, height } = useWindowSize();
    const { pathname } = useLocation();
    // handle navigation
    const handleNavigate = (path, isLink) => {
        // external link
        if (path.startsWith("http")) {
            // opne in a new tab
            window.open(path, "_blank", "noopener,noreferrer");
            return;
        }
        // if (isLink == true) {
        //     window.location.href = `tel:${path}`;
        // }
        /**TODO: if need to scroll to top even on the cureent page */
        // if (path === window.location.pathname.slice(1)) {
        //     window.scrollTo(0, 0);
        //     return;
        // }

        navigate(path);
    }

    const handleKeyDown = (e, path) => {
        // Key "Enter" to direct
        if (e.keyCode === 13) {
            if (path) {
                handleNavigate(path);
            }
        }
    }

    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });


    function handleResize () {
        //console.log('resize');
        pageRef.current.style.minHeight = "100vh";

        //console.log(footerRef.current);
        //console.log("InnerHeight: " + window.innerHeight);
        //console.log("Footer Offset: " + footerRef.current.offsetTop);

        //console.log("footerheight: " + footerRef.current.offsetHeight);
        //console.log("footerrefmargintop: " + footerRef.current.style.marginTop);
        //console.log(footerRef);
        //console.log("pagerefheight: " + pageRef.current.offsetHeight);
        if (window.innerHeight > footerRef.current.offsetTop) {
            //console.log(window.innerHeight - (footerRef.current.offsetTop));
            //console.log(pageRef);
            //console.log(pageRef.current.offsetHeight);
            const calcValue = window.innerHeight - (footerRef.current.offsetTop);
            pageRef.current.style.minHeight = `calc(100vh + ${footerRef.current.offsetHeight}px)`;
        }
    }

    useEffect(() => {
        // Handler to call on window resize



        // Call handler right away so state gets updated with initial window size

        // Check if the page has already loaded
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            handleResize();
            // Add event listener
            window.addEventListener('resize', handleResize);
        } else {
            window.addEventListener('load', handleResize, false);
            // Remove the event listener when component unmounts
            return () => window.removeEventListener('load', handleResize);
        }
        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount and unmount

    useEffect(() => {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            handleResize();
            // Add event listener
            window.addEventListener('resize', handleResize);
        } else {
            window.addEventListener('load', handleResize, false);
            // Remove the event listener when component unmounts
            return () => window.removeEventListener('load', handleResize);
        }
    }, [pathname])



    return (

        <Row ref={footerRef} className="footer-container w-100 m-0 mt-auto d-flex justify-content-center g-0 p-0 pt-5 pb-5">

            {/**TODO!!! 10/03/2025: in the future task */}
            {/* <Row className="m-0 d-flex justify-content-center top-section col-md-11 col-lg-9 p-0 pb-3 ">
                <Col xs={12} md={6} className="text-start  mb-4 mb-md-3">
                    <h5>Get email updates</h5>
                    <p>Sign up to get the latest information from PSOPPC.</p>
                </Col>
                <Col xs={12} md={6}>
                    <Form className="d-flex  mb-3 flex-column no-wrap ">
                        <Form.Label as="h5" htmlFor="email" className="text-start">Email</Form.Label>
                        <div className="d-flex flex-row gap-3">
                            <Form.Control
                                type="text"
                                id="email"
                                placeholder="Your email..."
                            />
                            <TextButton variant="normal" content={'Subscribe'}></TextButton>
                        </div>
                    </Form>
                    <img className="captcha-img mx-auto mb-5 me-md-0  mb-md-0" height='80' src={reCAPTCHA}></img>
                </Col>
            </Row> */}
            <Row className="d-flex flex-wrap flex-md-nowrap flex-column flex-md-row justify-content-center bottom-section col-md-11 col-lg-9 p-0 m-0 mb-5 pt-5 gap-2">
                <Col className="text-start d-flex flex-column align-items-center gap-5 align-items-md-start order-md-0 mb-5 mb-md-0">
                    <img height="62" title="Home" onClick={() => handleNavigate(PATHS.public.Homepage)} src={psoppclogo} alt="PSO Privacy Protection Center Logo"></img>
                    <img height="46" onClick={() => handleNavigate("https://www.ahrq.gov/policy/foia/index.html")} className="" src={ahrqlogo} alt="AHRQ Logo"></img>
                    <p>Contract No. 75Q80121C00004</p>
                </Col>
                <Col className="d-flex flex-column gap-2 text-center text-md-start mb-5 mb-md-0">
                    <p className="footer-col-header">Contact Us</p>
                    <p className="mt-1 ms-md-0"><LocalPhoneOutlinedIcon></LocalPhoneOutlinedIcon>&nbsp;866-571-7712</p>
                    <p><a className="footer-link" href="mailto:support@psoppc.org"><MailOutlinedIcon className="me-1"></MailOutlinedIcon>support@psoppc.org</a></p>
                    <p className='mt-1'><QueryBuilderIcon></QueryBuilderIcon>&nbsp;Mon.-Fri. 9:00 to 5:30 ET</p>
                </Col>
                <Col className="d-flex flex-column gap-2 text-center text-md-start mb-5  mb-md-0">
                    <p className="footer-col-header">Helpful Links</p>
                    <p><a tabIndex={0} className="footer-link" onKeyDown={(e) => handleKeyDown(e, PATHS.public['Terms of Use'])} onClick={() => handleNavigate(PATHS.public['Terms of Use'])}>Terms of Use</a></p>
                    <p><a tabIndex={0} className="footer-link" onKeyDown={(e) => handleKeyDown(e, PATHS.public['Accessibility'])} onClick={() => handleNavigate(PATHS.public['Accessibility'])}>Accessibility</a></p>
                    <p><a tabIndex={0} className="footer-link" onKeyDown={(e) => handleKeyDown(e, PATHS.public['Site Map'])} onClick={() => handleNavigate(PATHS.public['Site Map'])}>Site Map</a></p>
                    <p><a tabIndex={0} className="footer-link" onKeyDown={(e) => handleKeyDown(e, PATHS.public['Data Security'])} onClick={() => handleNavigate(PATHS.public['Data Security'])}>Data Security</a></p>
                    <p><a tabIndex={0} className="footer-link" onKeyDown={(e) => handleKeyDown(e, PATHS.public['External Link Disclaimer'])} onClick={() => handleNavigate(PATHS.public['External Link Disclaimer'])}>External Link Disclaimer</a></p>
                    {/**Example of <LinkButton> */}
                    {/* <LinkButton content={"Terms of Use"} className="footer-link mx-auto ms-md-0 text-start" onClick={() => handleNavigate(PATHS.public['Terms of Use'])}></LinkButton>*/}
                </Col>
                <Col className="d-flex flex-column gap-2  text-center text-md-start mb-5  mb-md-0">
                    <p className="footer-col-header">Information Governance</p>
                    <p><a tabIndex={0} className="footer-link" onKeyDown={(e) => handleKeyDown(e, PATHS.external['FOIA'])} onClick={() => handleNavigate(PATHS.external['FOIA'])}>Freedom of Information Act<LaunchIcon className="ms-1"></LaunchIcon></a></p>
                    <p><a tabIndex={0} className="footer-link" onKeyDown={(e) => handleKeyDown(e, PATHS.public['Privacy Policy'])} onClick={() => handleNavigate(PATHS.public['Privacy Policy'])}>Privacy Policy</a></p>
                </Col>
            </Row>

        </Row>
    );
}

export default PublicFooter;